import { FormLoader } from "../../icons/index";

const Loader = () => {
    return (
        <div className="flex flex-col justify-center items-center min-h-[751px] md:min-h-[768px] py-8 md:pt-[66px] md:pb-[105px] px-4 md:px-9">
            <div className="w-[200px] h-[200px] mx-auto">
                <FormLoader />
            </div>
        </div>
    );
};

export default Loader;
